export const APP_UI_CREATE_ACTION = "APP_UI_CREATE_ACTION";
export const APP_UI_CREATE_SUCCESS = "APP_UI_CREATE_SUCCESS";
export const APP_UI_CREATE_FAIL = "APP_UI_CREATE_FAIL";

export const APP_UI_UPDATE_ACTION = "APP_UI_UPDATE_ACTION";
export const APP_UI_UPDATE_SUCCESS = "APP_UI_UPDATE_SUCCESS";
export const APP_UI_UPDATE_FAIL = "APP_UI_UPDATE_FAIL";

export const APP_UI_DELETE_ACTION = "APP_UI_DELETE_ACTION";
export const APP_UI_DELETE_SUCCESS = "APP_UI_DELETE_SUCCESS";
export const APP_UI_DELETE_FAIL = "APP_UI_DELETE_FAIL";

export const APP_UI_CREATE_TRANSLATE_ACTION = "APP_UI_CREATE_TRANSLATE_ACTION";
export const APP_UI_CREATE_TRANSLATE_SUCCESS = "APP_UI_CREATE_TRANSLATE_SUCCESS";
export const APP_UI_CREATE_TRANSLATE_FAIL = "APP_UI_CREATE_TRANSLATE_FAIL";

export const APP_UI_UPDATE_TRANSLATE_ACTION = "APP_UI_UPDATE_TRANSLATE_ACTION";
export const APP_UI_UPDATE_TRANSLATE_SUCCESS = "APP_UI_UPDATE_TRANSLATE_SUCCESS";
export const APP_UI_UPDATE_TRANSLATE_FAIL = "APP_UI_UPDATE_TRANSLATE_FAIL";

export const APP_UI_DELETE_TRANSLATE_ACTION = "APP_UI_DELETE_TRANSLATE_ACTION";
export const APP_UI_DELETE_TRANSLATE_SUCCESS = "APP_UI_DELETE_TRANSLATE_SUCCESS";
export const APP_UI_DELETE_TRANSLATE_FAIL = "APP_UI_DELETE_TRANSLATE_FAIL";

export const APP_UI_RELOAD_DATA = "APP_UI_RELOAD_DATA";

export const WHITELIST_IP_DELETE_IP = "WHITELIST_IP_DELETE_IP";
export const WHITELIST_IP_DELETE_IP_SUCCESS = "WHITELIST_IP_DELETE_IP_SUCCESS";
export const WHITELIST_IP_DELETE_IP_FAIL = "WHITELIST_IP_DELETE_IP_FAIL";

export const WHITELIST_IP_CREATE_IP = "WHITELIST_IP_CREATE_IP";
export const WHITELIST_IP_CREATE_IP_SUCCESS = "WHITELIST_IP_CREATE_IP_SUCCESS";
export const WHITELIST_IP_CREATE_IP_FAIL = "WHITELIST_IP_CREATE_IP_FAIL";
